import * as types from "../actions/actionTypes"
const initialState = {
    loading:true,
    error:false,
    data: { data: [], links: {}, message: [], meta: {}, chart_data:{} }
};

const CashFlow = (state = initialState, action) => {
    switch (action.type) {
        case types.REMOVE_CASH_FLOW_REQUEST:
            return {...state, loading:true };
        case types.REMOVE_CASH_FLOW_SUCCESS:
            return {...state, ...action.payLoad, loading: false};
        case types.REMOVE_CASH_FLOW_FAILURE:
            return { ...state, ...action.payLoad, loading: false};
        case types.CASH_FLOW_REQUEST:
            return { ...state, loading: true, error: false };
        case types.CASH_FLOW_SUCCESS:
            return { ...state, ...action.payLoad, loading: false };
        case types.CASH_FLOW_FAILURE:
            return { ...state, ...action.payLoad, loading: false, error: true };
        default:
            return state;
    }
};

export default CashFlow;